

/// <reference path="PaymentTransaction.ts" />

// Generated class DevicePaymentTransaction_ManagedObject

class DevicePaymentTransaction_ManagedObject extends PaymentTransaction
{
}
